import { ChecklistTemplateRepository } from "../../repositories/ChecklistTemplateRepository";
import { ChecklistTemplateItemEntity } from "../../entities/ChecklistTemplateEntity";

/**
 * Get Template Items Use Case
 * Retrieves all items for a template
 */
export class GetTemplateItemsUseCase {
  constructor(private repository: ChecklistTemplateRepository) {}

  async execute(templateId: number): Promise<ChecklistTemplateItemEntity[]> {
    return await this.repository.getTemplateItems(templateId);
  }
}

